import { render, staticRenderFns } from "./reviewClaim.vue?vue&type=template&id=72b94079&scoped=true"
import script from "./reviewClaim.vue?vue&type=script&lang=js"
export * from "./reviewClaim.vue?vue&type=script&lang=js"
import style0 from "./reviewClaim.vue?vue&type=style&index=0&id=72b94079&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b94079",
  null
  
)

export default component.exports